import { IdName } from "../../models/IdName";
import { runAction } from "../client";
import { assertId } from "./common";

export interface GeotabVehiclesRequest
{
    GeotabAccountId: number;
    ExcludeRegistered: boolean;
}

export interface GeotabVehiclesResult
{
	GeotabVehicles: IdName[];
}

export interface GetGeotabVehiclesFn
{
    (serviceAccountId: number): Promise<GeotabVehiclesResult>;
}

export const getGeotabVehicles: GetGeotabVehiclesFn = (serviceAccountId: number) => {
    assertId({ serviceAccountId });
    
    const payload: GeotabVehiclesRequest = {
        GeotabAccountId: serviceAccountId,
        ExcludeRegistered: true
    };
    
    return runAction<GeotabVehiclesResult>('/action/GetGeotabVehicles', payload);
}


// WEBPACK FOOTER //
// ./src/rest/Geotab/vehicles.ts